// Copyright 2025-2026 - Hewlett Packard Enterprise Company

import { useContext } from 'react';
import { Box } from 'grommet';

import { SidebarContext } from '../../providers/SidebarProvider';
import { ChatProvider } from '../../providers/ChatProvider';
import ChatContainer from '../Chat/ChatContainer';
import Help from '../Help/Help';
import useFlags from '../../hooks/useFlags';

export default function SidebarContent({ width, ...rest }) {
  const flags = useFlags();
  const chatBotFlag = flags.T_20241210_53281_CHATBOT_SUPPORT_BOOL();
  const ahsSupportWorkspaceFlag =
    flags.P_20260320_4980_HPE_AHS_SUPPORT_WORKSPACE();
  let showChatBot = chatBotFlag;

  if (ahsSupportWorkspaceFlag) {
    showChatBot = chatBotFlag && flags.T_20260423_4980_ENABLE_AHS_COPILOT();
  }

  const { isChatOpen, setIsChatOpen } = useContext(SidebarContext);

  return (
    <ChatProvider>
      <Box border="left" width={width} fill overflow="auto" {...rest}>
        {showChatBot && isChatOpen && <ChatContainer onClose={setIsChatOpen} />}
        <Help width={width} />
      </Box>
    </ChatProvider>
  );
}
